

<template>
  <div >
    <h5>Activity Log</h5>
    <b-spinner v-if="!dataLoaded" variant="success" label="Spinning"></b-spinner>
    <b-alert :show="dataLoaded && error" variant="danger">{{errorText}}</b-alert>
    <b-table responsive small v-if="dataLoaded && !error" :items = 'items' style="max-height:500px">
    </b-table>

  </div>
</template>

<script>
import * as EventClient from '../clients/EventClient'
import moment from 'moment'
export default {
  name: 'LogTable',
  props: {
  },
  components: {
  },
  data () {
    return {
      title: 'LogTable',
      dataLoaded: false,
      error: false,
      errorText: undefined,
      items: undefined,
      intervalId: undefined
    }
  },
  methods: {
    loadPage: async function(reload) {
      if (!reload) this.dataLoaded = false
      try {
        var events = await EventClient.getEvents()
        this.items = events.data.map(e => {
          var time
          if (isToday(new Date(e.createdAt))) {
            time = moment(e.createdAt).format("HH:mm:ss")
          }else {
            time = moment(e.createdAt).format("DD-MMM HH:mm:ss")
          }
          return {time: time, process: e.process, content: e.content}
        })
        this.dataLoaded = true
        this.error = false
      }catch(err) {
        this.errorText = err
        this.error = true
        this.dataLoaded = true
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === "Dashboard") this.loadPage()
    }
  },
  activated () {
    this.loadPage()
    this.intervalId = setInterval(() => {
      this.loadPage(true)
    }, 10000)
  },
  destroyed() {
    clearInterval(this.intervalId)
  },
  deactivated() {
    clearInterval(this.intervalId)
  }
}

const isToday = (someDate) => {
  const today = new Date()
  return someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.green {
  background-color: green
}

.is-live {
  text-decoration: underline;
  font-weight: bold;
}
</style>
